module.exports = __webpack_public_path__ + "static/media/feature2proctoring.cdc738ab.png";